export const PLATFORM_ROLES = {
  ADMIN: 'PLATFORM:ADMIN',
  SUPER_ADMIN: 'PLATFORM:SUPER_ADMIN',
} as const
